module.exports = __webpack_public_path__ + "static/media/guvi.0044a509.png";